export const extractVariables = (message) => {
  const regex = /{([^}]+)}/g;
  const matches = message.match(regex);
  return matches ? Array.from(new Set(matches)) : [];
};
